// extracted by mini-css-extract-plugin
export default {"card__header":"Card_card__header__GnFFd","image":"Card_image__VMPdL","info":"Card_info__6GFHj","title":"Card_title__ag5LX","subtitle":"Card_subtitle__gj+5U"};